
import { defineComponent, ref } from 'vue'
import { Form, FormItem, Input, Select, SelectOption, DatePicker, Button } from 'ant-design-vue'
import 'ant-design-vue/lib/form/style/css'
import 'ant-design-vue/lib/date-picker/style/css'
import { AdvancedQueryConditionModal, MainModule } from '@/store/modules/main.store'
const dateValueFormat = 'YYYY-MM-DD 00:00:00'
export default defineComponent({
    components: {
        Form,
        FormItem,
        Input,
        Select,
        SelectOption,
        DatePicker,
        Button
    },
    setup () {
        const labelCol = ref({
            style: {
                width: '60px'
            }
        })
        const searchModel = ref<AdvancedQueryConditionModal>({
            createdAtFrom: '',
            createdAtTo: '',
            updatedAtFrom: '',
            updatedAtTo: '',
            lastLoginAtFrom: '',
            lastLoginAtTo: '',
            name: '',
            nickname: '',
            email: '',
            mobilePhone: '',
            phone: '',
            haveUserGroup: ''
        })
        function handleSubmit () {
            const searchParams: any = {};
            for (const key in searchModel.value) {
                if (searchModel.value[key]) {
                    searchParams[key] = searchModel.value[key]
                }
            }
            if (searchParams.haveUserGroup) {
                searchParams.haveUserGroup = searchParams.haveUserGroup === '1'
            }
            MainModule.changeDataFilter({
                searchType: 'advancedQuery',
                advancedQueryCondition: searchParams
            })
            console.log(searchParams);
        }
        return {
            labelCol,
            searchModel,
            handleSubmit,
            dateValueFormat
        }
    }
})
